export default "__VITE_ASSET__B9hsW_My__"